import { UploadFile } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Checkbox, Divider, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';

import { LayoutBase } from '../../layouts';
import { useAuthContext } from '../../context';
import { ToolsDetails } from '../../components/custom';
import { FilesType } from '../../environment';
import { DamsServices, IDamsList } from '../../services/api/dams/DamServices';
import { FileServicesBack, IFileServices } from '../../services/api/files/FileServicesBack';
import { ConfirmationDialog } from '../../components/shared/VConfirmationDialog';
import { CustomAlert } from '../../components/shared/VAlert';
import { VAutoCompletFiles } from '../../components/shared';

export const File = () => {

    const url = useParams();
    const navigate = useNavigate();
    const { userData } = useAuthContext();
    const [initType, setInitType] = useState<string[] | undefined>(undefined);
    const [dams, setDams] = useState<IDamsList[]>([]);
    const [tipoData, setTipoData] = useState<string[]>([]);
    const [isDialogOpen, setDialogOpen] = useState(false);
    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success'
    });
    const [data, setData] = useState<IFileServices>({
        file: null,
        lista_dam: [],
        titulo: '',
        data_emissao: '',
        descricao: '',
        tipo: [],
        classificacao: [],
        npgb: '',
    });

    const [validations, setValidations] = useState<{ [key: string]: boolean }>({
        titulo: false,
        descricao: false,
        tipo: false,
        lista_dam: false,
        file: false,
        data_emissao: false,
        npgb: false
    });

    useEffect(() => {
        fetchData();
        getTypeForUrl();
    }, []);


    function getTypeForUrl() {
        if (url.type) {
            if (url.type == 'foto') {
                setData(prevData => ({
                    ...prevData,
                    tipo: ['Registros Fotográficos'],
                }));
                setData(prevData => ({
                    ...prevData,
                    classificacao: ['informacoes_gerais'],
                }));
            } else if (url.type == 'fisb') {
                setData(prevData => ({
                    ...prevData,
                    tipo: ['Fichas de Inspeções de Segurança de Barragens (histórico)'],
                }));
                setData(prevData => ({
                    ...prevData,
                    classificacao: ['registros_e_controles'],
                }));
            } else if (url.type == 'risr') {
                setData(prevData => ({
                    ...prevData,
                    tipo: ['Relatório de Inspeção de Segurança Regular'],
                }));
                setData(prevData => ({
                    ...prevData,
                    classificacao: ['documentacao_tecnica_do_empreendimento'],
                }));
            } else if (url.type == 'rise') {
                setData(prevData => ({
                    ...prevData,
                    tipo: ['Relatório de Inspeção de Segurança Especial'],
                }));
                setData(prevData => ({
                    ...prevData,
                    classificacao: ['documentacao_tecnica_do_empreendimento'],
                }));
            } else if (url.type == 'Plano de Ação de Emergência') {
                setData(prevData => ({
                    ...prevData,
                    tipo: ['Plano de Ação de Emergência'],
                }));
                setData(prevData => ({
                    ...prevData,
                    classificacao: ['plano_de_acao_de_emergencia_pae'],
                }));
            } else if (url.type == 'Treinamento Interno Semestral') {
                setData(prevData => ({
                    ...prevData,
                    tipo: ['Treinamento Interno Semestral'],
                }));
                setData(prevData => ({
                    ...prevData,
                    classificacao: ['plano_de_acao_de_emergencia_pae'],
                }));
            } else if (url.type == 'Seminário Orientativo Anual') {
                setData(prevData => ({
                    ...prevData,
                    tipo: ['Seminário Orientativo Anual'],
                }));
                setData(prevData => ({
                    ...prevData,
                    classificacao: ['plano_de_acao_de_emergencia_pae'],
                }));
            } else if (url.type == 'Registro de Situação Emergência') {
                setData(prevData => ({
                    ...prevData,
                    tipo: ['Registro de Situação Emergência'],
                }));
                setData(prevData => ({
                    ...prevData,
                    classificacao: ['plano_de_acao_de_emergencia_pae'],
                }));
            } else if (url.type == 'Simulado de Situação de Emergência ') {
                setData(prevData => ({
                    ...prevData,
                    tipo: ['Simulado de Situação de Emergência'],
                }));
                setData(prevData => ({
                    ...prevData,
                    classificacao: ['plano_de_acao_de_emergencia_pae'],
                }));
            } else if (url.type == 'ACO') {
                setData(prevData => ({
                    ...prevData,
                    tipo: ['ACO'],
                }));
                setData(prevData => ({
                    ...prevData,
                    classificacao: ['plano_de_acao_de_emergencia_pae'],
                }));
            }
            // else {
            //     setInitType(undefined);
            // }
        }
    }

    const fetchData = () => {
        if (url.file && url.file !== 'new') {
            FileServicesBack.getById(url.file, 'False')
                .then((result) => {
                    if (result instanceof Error) {
                        alert(result.message);
                    } else {
                        setData(result.data);
                        const tipo: string = result.data.tipo.tipo;
                        if (tipoData.length === 0) {
                            const newTipoData: string[] = [tipo];
                            setTipoData(newTipoData);
                            setInitType(newTipoData);
                        }
                        console.log(result.data.barragens);
                        if(result.data.barragens){
                            
                            setData(prevData => ({
                                ...prevData,
                                lista_dam: Array.isArray(result.data.barragens)? result.data.barragens.map((barragem: { uuid: any; }) => barragem.uuid) : []
                            }));
                        }
                    }
                });
        }
        if (userData.id_empresa) {
            DamsServices.get(userData.id_empresa)
                .then((result) => {
                    if (result instanceof Error) {
                        alert(result.message);
                    } else {
                        const values = result.filter((dam) => dam.status === true);
                        setDams(values);
                    }
                });
        }
    };
    
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value, type, checked } = e.target;
        const convertedValue = type === 'checkbox' ? checked : type === 'number' ? parseFloat(value) : value;

        setData(prevData => ({
            ...prevData,
            [id]: convertedValue
        }));
    };

    function handleSelectDam(uuid: string) {
        setData(prevData => {
            const current = prevData?.lista_dam || [];

            const inCurrent = current.includes(uuid);

            let newList: string[];

            if(inCurrent){
                newList = current.filter(id => id !== uuid);
            }else{
                newList = [...current, uuid];
            }

            return {
                ...prevData,
                lista_dam: newList
            };
        });
        // setData(prevData => ({
        //     ...prevData,
        //     lista_dam: [...prevData?.lista_dam || [], uuid],
        // }));
    }

    function findArrayType(types: string[]): string[] {
        const arrayNames: string[] = [];

        types.forEach(type => {
            for (const key in FilesType) {
                if (Object.hasOwnProperty.call(FilesType, key)) {
                    const array = FilesType[key as keyof typeof FilesType];
                    if (array.includes(type)) {
                        arrayNames.push(key);
                        break;
                    }
                }
            }
        });
        return arrayNames;
    }

    function handleFileType(newValue: string[]) {

        if (newValue && newValue.length > 0) {
            setData(prevData => ({
                ...prevData,
                tipo: newValue,
            }));

            const arrayName = findArrayType(newValue);

            setData(prevData => ({
                ...prevData,
                classificacao: arrayName,
            }));
        } else if (newValue && newValue.length === 0 && data.tipo.length > 0) {
            setData(prevData => ({
                ...prevData,
                tipo: [],
                classificacao: [],
            }));
        }
    }

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const selectedFile = e.target.files[0];
            setData(prevData => ({
                ...prevData,
                file: selectedFile,
                nome_arquivo: selectedFile.name
            }));
        }
    };

    const handleSave = async () => {
        setAlertInfo({ open: false, message: 'Erro ao salvar! ', severity: 'error' });
        
        if (url.file && data !== undefined) {
            
            
            const isValid = await validateDate();
            
            if (isValid) {
                const payload = { ...data };

                if (payload.npgb === '') {
                    delete payload.npgb;
                }

                if(url.file === 'new'){
                    try {
                        const response = await FileServicesBack.create(payload);
    
                        if (response instanceof Error) {
                            setAlertInfo({ open: true, message: 'Não foi possível salvar o documento! ' + response.message, severity: 'error' });
                        } else {
                            setAlertInfo({ open: true, message: 'Documento salvo! ', severity: 'success' });
                        }
                        
                        setTimeout(() => {
                            navigate(`/information_dam/${url.dam}/files/file`);
                        }, 1500);
    
                    } catch (error) {
                        setAlertInfo({ open: true, message: 'Erro ao salvar! ', severity: 'error' });
                    }

                }else if(url.file !== undefined && url.file !== 'new') {
                    console.log(data, url.file, 'aaaaaaaaaaaaaaaaa');
                    try {
                        const response = await FileServicesBack.upgrade(url.file, payload);
    
                        if (response instanceof Error) {
                            setAlertInfo({ open: true, message: 'Não foi possível atualizar o documento! ' + response.message, severity: 'error' });
                        } else {
                            setAlertInfo({ open: true, message: 'Documento atualizado! ', severity: 'success' });
                        }
                        
                        setTimeout(() => {
                            navigate(`/information_dam/${url.dam}/files/file`);
                        }, 1500);
    
                    } catch (error) {
                        setAlertInfo({ open: true, message: 'Erro ao atualizar! ', severity: 'error' });
                    }
                }

            }
        }
    };

    const handleDelete = async () => {
        if (url.file !== undefined && url.dam) {
            const result = await FileServicesBack.deleteById(url.file);
            if (result instanceof Error) {
                setAlertInfo({ open: true, message: 'Não foi possível excluir o documento! ' + result.message, severity: 'error' });
                setTimeout(() => {
                    navigate(`/information_dam/${url.dam}/files/file`);
                }, 2000);
            }
            else {
                setAlertInfo({ open: true, message: 'Documento excluído com sucesso!', severity: 'success' });
                setTimeout(() => {
                    navigate(`/information_dam/${url.dam}/files/file`);
                }, 2000);
            }
        }
        setDialogOpen(false);
    };

    const isNpgbRequired = Array.isArray(data?.tipo) && [
        'Relatório de Inspeção de Segurança Regular',
        'Relatório de Inspeção de Segurança de Rotina'
    ].some(tipo => data.tipo.includes(tipo));

    async function validateDate() {
        if (url.file && url.file !== 'new') {
            
            const newValidations = {
                titulo: !data.titulo,
                // descricao: !data.descricao,
                data_emissao: !data.data_emissao,
                lista_dam: !data.lista_dam,
                tipo: data.tipo.length == 0,
            };
            setValidations(newValidations);
            const isAnyInvalid = Object.values(newValidations).some(value => value);
            return !isAnyInvalid;
        } else {
            const newValidations = {
                titulo: !data.titulo,
                // descricao: !data.descricao,
                file: !data.file,
                data_emissao: !data.data_emissao,
                lista_dam: data.lista_dam.length == 0,
                tipo: data.tipo.length == 0,
                npgb: isNpgbRequired && !data.npgb,
            };
            setValidations(newValidations);
            const isAnyInvalid = Object.values(newValidations).some(value => value);
            return !isAnyInvalid;
        }
    }

    const handleClickOpen = () => {
        setDialogOpen(true);
    };

    const handleClose = () => {
        setDialogOpen(false);
    };

    const onChangeNpgb = (event: SelectChangeEvent<string>) => {
        const { value } = event.target;
        setData(prevData => ({
            ...prevData, 
            npgb: value,
        }));
    };

    const tiposDeRelatorio = [
        'Relatório de Inspeção de Segurança Regular',
        'Relatório de Inspeção de Segurança de Rotina'
    ];

    const deveExibirNpgb = Array.isArray(data?.tipo) && tiposDeRelatorio.some(tipo => data.tipo.includes(tipo));        

    return (

        <LayoutBase title={url.file == 'new' ? 'Cadastro de Arquivos' : 'Cadastro de Arquivos'}
            tollBar={
                <ToolsDetails
                    onClickSave={handleSave}
                    onClickDelet={handleClickOpen}
                />
            }
        >
            <Box display={'flex'} flexDirection={'column'}>
                <Grid container direction={'column'} padding={2} spacing={2}>
                    <Grid container item direction={'row'} spacing={4}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Typography variant='h6'>Passo 1 - Selecionar arquivo</Typography>

                            <Box display={'flex'} flexDirection={'row'} marginTop={2} gap={1} alignItems={'center'} justifyContent={'start'} marginBottom={2}>
                                <Button component="label" role={undefined} variant="contained" tabIndex={-1} startIcon={<UploadFile />} htmlFor="file-input" color={validations.file ? 'error' : 'primary'} sx={{ borderRadius: '25px' }}>
                                    Upload file
                                    <input required id="file-input" type="file" onChange={handleFileChange} hidden accept='.txt, .png, .jpg, .pdf, .jpeg, .docx, .doc, .rar, .zip' />
                                </Button>
                                <Typography variant='inherit'>{data.file ? data.file.name : 'Nenhum arquivo selecionado'}</Typography>
                            </Box>
                            <Typography variant='body2' fontSize={10}>Considere utilizar uma internet rápida para subir arquivos que possuem tamanho maior que 1gb</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <Typography variant='h6'>Passo 2 - Descreva o arquivo</Typography>

                            <Box display={'flex'} flexDirection={'column'} marginTop={2} gap={1}>
                                <FormGroup>
                                    <InputLabel><Typography>Nome do arquivo / Código</Typography></InputLabel>
                                    <TextField required id='titulo' value={data?.titulo || ''} onChange={handleChange} error={validations.titulo} fullWidth />
                                </FormGroup>
                                <FormGroup>
                                    <InputLabel><Typography>Descrição</Typography></InputLabel>
                                    <TextField id='descricao' multiline rows={4} value={data?.descricao || ''} onChange={handleChange} error={validations.descricao} fullWidth />
                                </FormGroup>
                                <FormGroup>
                                    <InputLabel><Typography>Data de Emissão</Typography></InputLabel>
                                    <TextField required type='date' id='data_emissao' value={data?.data_emissao || ''} onChange={handleChange} error={validations.data_emissao} fullWidth />
                                </FormGroup>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <Typography variant='h6' >Passo 3 - Para quais estruturas?</Typography>
                            <Box display={'flex'} flexDirection={'column'} marginTop={2} gap={1} marginLeft={1}>
                                {dams.map(dam => {
                                    const isChecked = data?.lista_dam?.includes(dam.uuid);
                                    return (
                                        <FormGroup key={dam.uuid}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        id={`lista_dam_${dam.uuid}`}
                                                        color='primary'
                                                        onChange={() => handleSelectDam(dam.uuid)}
                                                        checked={isChecked}
                                                    />
                                                }
                                                label={dam.nome}
                                            />
                                        </FormGroup>
                                    );
                                })}
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container item direction={'row'} spacing={2}>
                        <Grid item xs={12}>
                            <Divider orientation='horizontal' />
                        </Grid>
                        <Grid item xs={12}>
                            {initType !== undefined ?
                                <VAutoCompletFiles initValue={initType} onChange={(event, newValue) => handleFileType(newValue)} />
                                :
                                <VAutoCompletFiles initValue={data.tipo} onChange={(event, newValue) => handleFileType(newValue)} />
                            }
                        </Grid>
                        <Grid item xs={12}>
                            {deveExibirNpgb && (
                                <FormControl fullWidth required error={validations.npgb}>
                                    <InputLabel id="npgb-select-label">Nível de Perigo Global da Barragem(NPGB)</InputLabel>
                                    <Select
                                        labelId="npgb-select-label"
                                        label="Nível de Perigo Global da Barragem(NPGB)"
                                        value={data.npgb || ''}
                                        onChange={onChangeNpgb}
                                    >
                                        <MenuItem value="Normal">Normal</MenuItem>
                                        <MenuItem value="Atenção">Atenção</MenuItem>
                                        <MenuItem value="Alerta">Alerta</MenuItem>
                                        <MenuItem value="Emergência">Emergência</MenuItem>
                                    </Select>
                                    {validations.npgb && <FormHelperText>NPGB é obrigatório</FormHelperText>}
                                </FormControl>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            {alertInfo.open &&
                <CustomAlert
                    message={alertInfo.message}
                    severity={alertInfo.severity}
                />
            }
            <ConfirmationDialog
                isOpen={isDialogOpen}
                onClose={handleClose}
                onConfirm={handleDelete}
                title='Excluir Arquivo'
                message='Tem certeza que deseja excluir o documento?'
            />
        </LayoutBase>

    );
};